import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    useAccordionItemContext,
} from '@reach/accordion';

import { ChevronDownIcon } from 'icons';
import { Emoji } from 'components/Emoji';
import { Grid } from 'components/Grid';
import { Heading, HeadingBoundary } from 'components/Heading';
import { Text } from 'components/Text';
import { cx } from 'utility';
import * as styles from './FAQList.module.scss';

const propTypes = {
    className: PropTypes.string,
    items: PropTypes.array,
};

const defaultProps = {
    className: '',
    items: [],
};

function getClasses({ className }) {
    const classes = cx(
        className,
        styles['faqList'],
    );

    return classes || undefined;
}

function FAQList({
    className,
    items,
}) {
    const classes = getClasses({ className });

    return (
        <Accordion className={classes} collapsible>
            <Grid>
                <div className={styles['container']}>
                    {items.map(({ faq_answer, faq_question }, index) => {
                        const answer = faq_answer?.text;
                        const question = faq_question?.text;

                        return (
                            <AccordionItem className={styles['item']} key={`faq-item-${index}`}>
                                <HeadingBoundary>
                                    <Emoji className={styles['emoji']} emoji="💬" />
                                    <div className={styles['contentContainer']}>
                                        <AccordionItemChildren answer={answer} question={question} />
                                    </div>
                                </HeadingBoundary>
                            </AccordionItem>
                        );
                    })}
                </div>
            </Grid>
        </Accordion>
    );
}

function AccordionItemChildren({
    answer,
    question,
}) {
    const { index, isExpanded } = useAccordionItemContext();
    const [height, setHeight] = useState(0);
    const ref = useRef(null);
    const panelHeightStyle = {
        height: isExpanded ? height : 0,
    };

    useEffect(() => {
        setHeight(ref.current.clientHeight);
    });

    return (
        <>
            {question && (
                <AccordionButton className={styles['questionButton']}>
                    <Heading className={styles['question']} size={5}>
                        {question}
                        <ChevronDownIcon className={styles['questionButtonIcon']} />
                    </Heading>
                </AccordionButton>
            )}
            {answer && (
                <AccordionPanel className={styles['answerPanel']} style={panelHeightStyle}>
                    <div ref={ref}>
                        <Text as="p" className={styles['answer']} size={2}>
                            {answer}
                        </Text>
                    </div>
                </AccordionPanel>
            )}
        </>
    )
}

FAQList.propTypes = propTypes;
FAQList.defaultProps = defaultProps;

export { FAQList };
